const SvgParagon = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M16 21a5 5 0 1 1 .001-10.001A5 5 0 0 1 16 21m-4-5a4 4 0 1 0 8 0 4 4 0 0 0-8 0m16-8a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zM4 7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
  </svg>;
export default SvgParagon;